module.exports = __webpack_public_path__ + "assets/img/icon11.4dc90efb.svg";